import { render, staticRenderFns } from "./OrgRolesTable.vue?vue&type=template&id=485ce252"
import script from "./OrgRolesTable.vue?vue&type=script&lang=js"
export * from "./OrgRolesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports